<template>
  <Modal v-if="isEmbedderCodeModalShowing" @onCloseModal="onClose">
    <div class="modal-header">
      <h5>การฝัง URL </h5>
      <button
        @click="onClose"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form @submit.prevent="onConfirm">
      <div class="modal-body">
        <p>วางลิงก์ของเนื้อหาที่คุณต้องการแสดงบนหน้าเวปไซด์ของคุณ</p>
        <input class="form-control" v-model="embedLink" />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-light"
          @click.stop="onClose">
          ยกเลิก
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="!isValid">
          ฝัง
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
import { parseURLToEmbedURL } from '@/utils/embeddedURLManagement';
import Modal from '@/components/Modal.vue';

export default {
  props: {
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      isEmbedderCodeModalShowing: false,
      embedLink: null,
      command: null,
    };
  },
  computed: {
    isValid() {
      if (!this.embedLink) {
        return false;
      }
      return true;
    },
  },
  methods: {
    onClose() {
      this.isEmbedderCodeModalShowing = false;
    },
    onShowEmbedderCodeModal(command) {
      this.command = command;
      this.isEmbedderCodeModalShowing = !this.isEmbedderCodeModalShowing;
    },
    onCloseEmbedderCodeModal() {
      this.isEmbedderCodeModalShowing = false;
    },
    onConfirm() {
      // Some check can be done here, like if `youtubeID` is not false.
      const data = {
        command: this.command,
        data: {
          src: parseURLToEmbedURL(this.embedLink),
        },
      };

      this.$emit('onSubmit', data);
      this.embedLink = null;
      this.onCloseEmbedderCodeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

</style>
